/**
 * useCredits - Hook for managing user credits
 *
 * Thin wrapper around CreditContext. All state is shared across
 * the app — no redundant API calls when switching between pages.
 */

import { useCreditContext } from '@/contexts/CreditContext';

// Re-export types for backward compatibility
export type {
  CreditBalance,
  CreditPack,
  CreditEstimate,
  CreditTransaction,
} from '@/contexts/CreditContext';

export function useCredits() {
  return useCreditContext();
}
